import axios from "axios";
import { Navigate } from "react-router-dom";
import { backendUrl } from "../constants";

export const userData = JSON.parse(localStorage.getItem("userData"));
export const userRole = userData?.role || null;

export const axiosGet = async (url, params, headers) => {
  let response;
  try {
    response = await axios.get(backendUrl + url, {
      params,
      headers: {
        Authorization: `Bearer ${userData?.token}`,
        ...headers,
      },
    });
  } catch (err) {
    console.log(err);
    // response = err.response;
  }

  console.log(response);
  return response;
};

export const axiosPost = async (url, data, params, headers) => {
  const response = await axios.post(backendUrl + url, data, {
    params,
    headers: {
      Authorization: `Bearer ${userData?.token}`,
      ...headers,
    },
  });
  return response;
};

export const axiosPut = async (url, data, params, headers) => {
  const response = await axios.put(backendUrl + url, data, {
    params,
    headers: {
      Authorization: `Bearer ${userData?.token}`,
      ...headers,
    },
  });
  return response;
};

export const axiosPatch = async (url, data, params, headers) => {
  const response = await axios.patch(backendUrl + url, data, {
    params,
    headers: {
      Authorization: `Bearer ${userData?.token}`,
      ...headers,
    },
  });
  return response;
};

export const axiosDelete = async (url, data) => {
  const response = await axios.delete(backendUrl + url, {
    headers: {
      Authorization: `Bearer ${userData?.token}`,
    },
  });
  return response;
};

export const allowUserLogin = async (userType) => {
  let loggedInUser = JSON.parse(localStorage.getItem("userData"));
  // Check if a user is logged in or not
  if (
    loggedInUser !== "null" &&
    loggedInUser !== "undefined" &&
    loggedInUser !== undefined &&
    loggedInUser !== null
  ) {
    // If the user exists check which type of user it is

    if (loggedInUser.role !== userType) {
      window.location.href =
        loggedInUser.role === "Admin"
          ? "/admin/"
          : loggedInUser.role === "Company"
          ? "/employer/"
          : loggedInUser.role === "JobSeeker"
          ? "/jobseeker/"
          : "/login";
      return true;
    } else if (userType === loggedInUser.role) {
      return true;
    } else {
      return false;
    }
  } else {
    window.location.href = "/login";
    return false;
  }
};
